import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';
import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject, Subscription, timer } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { CustomSocketService } from 'src/app/services/custom-socket.service';
import { Router } from '@angular/router';
import { NotificationsService } from 'src/app/services/notifications.service';
const CHAT_PAGE = '/pages/chat';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  selectedItem = "";
  public user: any;
  message_Comp_notifs: string[] = [];
  message_Contacts_notifs: string[] = [];

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false
  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = [{ title: 'Profile' }, { title: 'Log out' }];

  notifications_num: number = 0;
  notifUnread: number = 0;
  notifUnreadChat: number = 0;
  notifUnreadCompe: number = 0;
  notifUnreadContacts: number = 0;
  mySub: Subscription;
  tab: string = 'notifications';
  userMenuItems = [
    { title: 'My Profile' },
    { title: 'My Connections' },
    { title: 'My Gamified Route' },
    { title: 'Gamification Analytics' },
    { title: 'Notifications' },
    { title: 'Account & Settings' },
    { title: 'Logout' }
  ];
  sub: Subscription;
  notifications: Subscription;
  message: string = '';
  message_chat: string[] = [];
  message_notifs: string[] = [];
  timer: number = 5;
  trigger: boolean = false;


  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserData,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private authService: AuthService,
    private socket: CustomSocketService,
    private router: Router,
    private nbMenuService: NbMenuService,
    private notification: NotificationsService) {
  }

  ngOnInit() {
    // console.log("header")
    // this.currentTheme = this.themeService.currentTheme;
    // this.themeService.onThemeChange()
    //   .pipe(
    //     map(({ name }) => name),
    //     takeUntil(this.destroy$),
    //   )
    //   .subscribe(themeName => this.currentTheme = themeName);
    this.init();
    this.getChatNotis();
    this.getNotCompetition();
    this.getNotificationContact();
    // this.getAllByUserNotis();
  }

  ngOnDestroy() {
    this.socket.emit('removeUser', this.user.id);
    this.socket.removeAllListeners();
    this.socket.disconnect();
    this.notifications.unsubscribe();
    this.sub.unsubscribe();
    if (this.notifications_num > 0) 
    // this.mySub.unsubscribe();
    if (this.router.url == CHAT_PAGE) {
      this.authService.chatObject.next(true);
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  init() : void {
    this.socket.connect();
    this.notifications = this.socket.fromEvent<any>('notifications').subscribe(payload => {
      if(payload) {
        this.message = payload.data.message;
        this.trigger = true;
        this.mySub = timer(this.timer * 1000).subscribe(val => this.trigger = false);
        // this.notifications_num = this.notifications_num + 1;
        this.getChatNotis();
      }
    });
    this.socket.emit('addUser', JSON.parse(this.authService.getUser()).id);

    this.currentTheme = this.themeService.currentTheme;

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

    this.authService.userSubject.subscribe((user) => {
      this.user = user;
      // console.log(this.user)
    });
    this.sub = this.nbMenuService.onItemClick().subscribe((res) => {
      if (res.tag === 'my-user-menu') {
        if (res.item.title === 'My Profile') {
          if(this.router.url.includes('/pages/profile/')) this.authService.profileObj.next(0);
          else this.router.navigate(['pages', 'profile', '0']);
        }
        if (res.item.title === 'My Connections') {
          if(this.router.url.includes('/pages/profile/')) this.authService.profileObj.next(1);
          else this.router.navigate(['pages', 'profile', '1']);
        }
        if (res.item.title === 'My Gamified Route') {
          if(this.router.url.includes('/pages/profile/')) this.authService.profileObj.next(2);
          else this.router.navigate(['pages', 'profile', '2']);
        }
        if (res.item.title === 'Gamification Analytics') {
          if(this.router.url.includes('/pages/profile/')) this.authService.profileObj.next(3);
          else this.router.navigate(['pages', 'profile', '3']);
        }
        if (res.item.title === 'Notifications') {
          if(this.router.url.includes('/pages/profile/')) this.authService.profileObj.next(4);
          else this.router.navigate(['pages', 'profile', '4']);
        }
        if (res.item.title === 'Account & Settings') {
          if(this.router.url.includes('/pages/profile/')) this.authService.profileObj.next(5);
          else this.router.navigate(['pages', 'profile', '5']);
        }
        if (res.item.title === 'Logout') {
          this.signOut();
        }
      }
    });
  }

  // isHeaderVisible(): boolean {
  //   const urlsWithoutHeader: string[] = ['/eligibility-tool'];
  //   return this.authService.isLoggedIn() && !urlsWithoutHeader.includes(this.router.url);
  // }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  signOut(): void {
    this.authService.logout();
  }


  resetNotifications(table: string): void {
    this.notification.changeNotificationStatus(table).subscribe(res=>{});
    // this.notifications_num = 0;
    document.getElementById("notiNum").style.display;
  }
  
  selectTab(event: any): void {
    if(event.tabTitle == 'Chat') {
      this.resetNotifications('chatHistory');
      this.tab = 'chatHistory';
      this.notifUnreadChat=0;
      this.notifUnread=0;
      this.totalNotifs()
    }
    else if(event.tabTitle == 'Contacts' ) {
      this.resetNotifications('notifications_contacts');
      this.tab = 'notifications_contacts'
      this.notifUnreadContacts = 0;
      this.totalNotifs()
    }
    else if(event.tabTitle == 'Competition')
    {
      this.resetNotifications('notifications_competition');
      this.tab = 'notifications_competition'
      this.notifUnreadCompe=0;
      this.totalNotifs()

    }
  }


  getChatNotis(): void{
    var unreadNotifs = [], readNotifs = [] ; 
    this.notifications_num = 0;  
    this.notifUnread=0; 
    this.notifUnreadChat=0
    // this.notification.getUnreadUserNotifications('notifications').subscribe(res => {
    //   if(res && res.length > 0){
    //     unreadNotifs = [], readNotifs = [] ;
    //     res.forEach(el => {
    //       if(el.status == 'unread') unreadNotifs.push({message: el.message, type: el.type, senderId: el.senderId});
    //       else readNotifs.push({message: el.message, type: el.type, senderId: el.senderId});
    //     });
    //     this.message_notifs = [ ...unreadNotifs, ...readNotifs ]        
    //     this.notifications_num += unreadNotifs.length;      
    //     this.notifUnread+=  unreadNotifs.length;  
    //   }
    // });
    this.notification.getUnreadUserNotifications('chatHistory').subscribe(res => {
      if(res && res.length > 0){
        unreadNotifs = [], readNotifs = [] ;
        
        res.forEach(el => {
          if(el.status == 'unread') unreadNotifs.push(el.message);
          else readNotifs.push(el.message);
        });
        this.message_chat = [ ...unreadNotifs, ...readNotifs ]
        this.notifications_num += unreadNotifs.length;
        this.notifUnreadChat+=  unreadNotifs.length;  
      }
    });
    // console.log(this.notifications_num)

  }





getNotificationContact(){
  var unreadNotifs = [], readNotifs = [] ; 
    this.notifUnreadContacts=0;
    this.notification.getUnreadUserNotifications('notifications_contacts').subscribe(res=>{
      if(res && res.length > 0){
        unreadNotifs = [], readNotifs = [] ;
        res.forEach(el => {
          if(el.status == 'unread') unreadNotifs.push({message: el.message, type: el.type, senderId: el.senderId});
          else readNotifs.push({message: el.message, type: el.type, senderId: el.senderId});
        });
        this.message_Contacts_notifs = [ ...unreadNotifs, ...readNotifs ]        
        this.notifications_num += unreadNotifs.length;  
        this.notifUnreadContacts +=unreadNotifs.length;     
      }
      // console.log(this.notifications_num)
    })
}







  getNotCompetition(){
    var unreadNotifs = [], readNotifs = [] ; 
    this.notifUnreadCompe=0;
    this.notification.getUnreadUserNotifications('notifications_competition').subscribe(res=>{
      if(res && res.length > 0){
        unreadNotifs = [], readNotifs = [] ;
        res.forEach(el => {
          if(el.status == 'unread') unreadNotifs.push({message: el.message, type: el.type, senderId: el.senderId});
          else readNotifs.push({message: el.message, type: el.type, senderId: el.senderId});
        });
        this.message_Comp_notifs = [ ...unreadNotifs, ...readNotifs ]        
        this.notifications_num += unreadNotifs.length;  
        this.notifUnreadCompe +=unreadNotifs.length;     
      }
      // console.log(this.notifications_num)
    })
  }

  totalNotifs(){
    this.notifications_num = this.notifUnreadCompe + this.notifUnreadContacts +  this.notifUnreadChat
  }
}
